<template>
  <div>
    <h2 class="text-left alert" :class="[ removed ? 'alert-danger' : 'alert-success' ]">
      Culling
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[ removed ? 'glyphicon-plus' : 'glyphicon-remove' ]"></span>
      </a>
    </h2>

    <template v-if="!removed">
      <div class="text-left step-section">
        <div v-for="farm in model.FARMS" :key="farm.id">
          <h3 class="text-left" :class="isRemovedSubsection(`farm_${farm.id}-culling`) ? 'comment-disabled' : ''">
            {{ farm.farm_label }}
            <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, `farm_${farm.id}-culling`)">
              <span class="glyphicon" :class="isRemovedSubsection(`farm_${farm.id}-culling`) ? 'glyphicon-plus' : 'glyphicon-remove'"></span>
            </a>
          </h3>

          <dl class="dl-horizontal">
            <dt>Culled for mastitis in the last two seasons</dt>
            <dd>{{ model[`farm_${farm.id}-has_prev_culled_for_mastitis`] || '-' }}</dd>
          </dl>
          <report-comment :field_name="`farm_${farm.id}-has_prev_culled_for_mastitis`" :model="model.COMMENTS" :heading="false">
          </report-comment>

          <dl class="dl-horizontal">
            <dt>Number culled in current season for mastitis issues:</dt>
            <dd>{{ model[`farm_${farm.id}-num_culled_for_matitis`] || '-' }}</dd>
          </dl>

          <dl class="dl-horizontal">
            <dt>Herd Testing</dt>
            <dd>{{ model[`farm_${farm.id}-has_herd_tested`] || '-' }}</dd>
          </dl>

          <dl class="dl-horizontal">
            <dt>Number of herd tests:</dt>
            <dd>{{ model[`farm_${farm.id}-num_herd_tests`] || '-' }}</dd>
          </dl>

          <dl class="dl-horizontal">
            <dt>Culling criteria</dt>
            <dd>{{ model.COMMENTS.current[`farm_${farm.id}-culling_criteria`] || '-' }}</dd>
          </dl>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'
import ReportComment from '../ReportComment'

export default {
  mixins: [ mixin ],
  props: ['model'],
  components: {
    ReportComment
  },
  data() {
    return {
      stepName: 'Culling',
    }
  },
};
</script>
